import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import TableHead from './TableHead';

class TableHeads extends PureComponent {
  render() {
    const { tableHeads, onSort  } = this.props;
    const tableHeadList = tableHeads.map(
      tableHead => <TableHead key={tableHead.id} tableHead={tableHead} onSort={onSort} />,
    );
    return (
      <thead>
        <tr>
          { tableHeadList }          
        </tr>
      </thead>
    );
  }
}

// props validation
TableHeads.propTypes = {
  tableHeads: PropTypes.arrayOf(PropTypes.object),
};

TableHeads.defaultProps = {
  tableHeads: [{
    id: '1',
    name: 'N°',
    class: 'w-7',
    prop: 'id'
  }, {
    id: '2',
    name: 'Código',
    class: 'w-20',
    prop: 'code'
  }, {
    id: '3',
    name: 'Clase',
    class: 'w-12',
    prop: 'class'
  }, {
    id: '4',
    name: 'Tipo',
    class: 'w-10',
    prop: 'type'
  }, {
    id: '5',
    name: 'Nombre',
    class: 'w-5',
    prop: 'name'
  }, {
    id: '6',
    name: 'Gasto previo',
    class: 'w-10',
    prop: 'contractMondification'
  },{
    id: '7',
    name: 'Monto total',
    class: 'w-5',
    prop: 'totalAmount'
  },{
    id: '7',
    name: 'Código interno',
    class: 'w-17',
    prop: 'internalCode'
  },{
    id: '8',
    name: 'Action',
    class: 'w-14',
    prop: ''
  }],
};

export default TableHeads;